import { filterSummary } from './filterSummary';

const MAX_INLINE_BUYERS = 3;

interface FilterPart {
  selectedLabels: string[];
  totalCount: number;
  allLabel: string;
  prefix: string;
  everyPickNarrows?: boolean;
}

export interface FiltersSummaryInput {
  divisions: FilterPart;
  locations: FilterPart;
  lineTypes: FilterPart;
  /** One part per active shared procurement filter (POP, SKU search, ...). */
  sharedParts: string[];
  readiness: FilterPart;
  /** The days-on-order floor; undefined when every age is listed. */
  minDaysOnOrder: number | undefined;
  /** Text for an active days-on-order filter. */
  daysOnOrderLabel: (days: number) => string;
  /** Selected buyer codes; empty means every buyer. */
  buyerCodes: string[];
  allBuyersLabel: string;
  /** Text for a buyer filter naming up to three codes, joined with commas. */
  buyersLabel: (codes: string) => string;
  /** Text for a buyer filter with more picks than fit inline. */
  buyersCountLabel: (count: number) => string;
  vendorCount: number;
  allVendorsLabel: string;
  /** Text for a vendor filter with `count` picks. */
  vendorsLabel: (count: number) => string;
}

/**
 * The collapsed filters line: each active filter in the same words its
 * multi-select shows, joined with a middle dot.
 */
function buyersPart(input: FiltersSummaryInput): string {
  const count = input.buyerCodes.length;
  if (count === 0) return input.allBuyersLabel;
  if (count > MAX_INLINE_BUYERS) return input.buyersCountLabel(count);
  return input.buyersLabel(input.buyerCodes.join(', '));
}

export function filtersSummaryLine(input: FiltersSummaryInput): string {
  return [
    filterSummary(input.divisions),
    filterSummary(input.locations),
    input.vendorCount > 0
      ? input.vendorsLabel(input.vendorCount)
      : input.allVendorsLabel,
    buyersPart(input),
    ...input.sharedParts,
    filterSummary(input.lineTypes),
    filterSummary(input.readiness),
    ...(input.minDaysOnOrder === undefined
      ? []
      : [input.daysOnOrderLabel(input.minDaysOnOrder)]),
  ].join(' · ');
}
